// src/components/dashboard/CreateDossier.js - VERSION QUI FONCTIONNE AVEC DEBUG
import React, { useState, useEffect, useRef } from "react";
import {
  collection,
  addDoc,
  getDocs,
  query,
  where,
  doc,
  Timestamp,
  setDoc,
  getDoc,
} from "firebase/firestore";
import { db } from "../../firebase/config";
import { useNavigate } from "react-router-dom";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import { initializeApp } from "firebase/app";
import emailjs from "@emailjs/browser";

// Services
import { createNotification } from "../../services/notificationService";

// Configuration EmailJS
const EMAIL_SERVICE_ID = "service_ckov80p";
const EMAIL_TEMPLATE_ID = "template_b17il7n";
const EMAIL_PUBLIC_KEY = "-RBuLnwTHt3kUx0T_"; // ✅ Clé publique utilisée pour l'initialisation

// NOUVEAU: Fonction pour vérifier si un projet similaire existe
const checkDuplicateProject = (existingProjects, newProject) => {
  return existingProjects.find(project => 
    project.clientEmail === newProject.emailClient &&
    project.title === newProject.titre &&
    project.clientAddress === newProject.adresseClient &&
    project.typeClient === newProject.typeClient
  );
};

export default function CreateDossier() {
  const navigate = useNavigate();

  // État initial du formulaire
  const [form, setForm] = useState({
    titre: "",
    description: "",
    nomClient: "",
    emailClient: "",
    telephoneClient: "",
    adresseClient: "",
    gps: "",
    typeClient: "professionnel",
    chargeAffaires: [],
    chefsProjets: [],
    superAdmins: [],
    sourceContact: "",
    raccordement: "autoconsommation",
    dateLimite: new Date(
      new Date().setMonth(new Date().getMonth() + 3)
    ).toISOString(),
    puissanceInstallation: "", // Champ ajouté
  });

  const [users, setUsers] = useState([]);
  const inputRef = useRef(null);

  // Config Firebase secondaire
  const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
  };

  const secondaryApp = initializeApp(firebaseConfig, "secondary");
  const secondaryAuth = getAuth(secondaryApp);
  const mainAuth = getAuth();

  // Initialisation EmailJS (une seule fois)
  useEffect(() => {
    try {
      emailjs.init(EMAIL_PUBLIC_KEY); // ✅ Utilisation de la clé publique
      console.log("✅ EmailJS initialisé");
    } catch (error) {
      console.error("❌ Erreur lors de l'initialisation d'EmailJS:", error);
    }
  }, []);

  // Fetch utilisateurs
  useEffect(() => {
    (async () => {
      const snap = await getDocs(collection(db, "users"));
      const allUsers = snap.docs.map((d) => ({
        id: d.id,
        ...d.data(),
      }));
      setUsers(allUsers);
    })();
  }, []);

  // Google Places Autocomplete
  useEffect(() => {
    let isSelectingFromAutocomplete = false;

    const initAutocomplete = () => {
      if (!inputRef.current || !window.google?.maps?.places) return;

      const ac = new window.google.maps.places.Autocomplete(inputRef.current, {
        types: ["address"],
      });

      // Gestion sélection Google Maps
      ac.addListener("place_changed", () => {
        const place = ac.getPlace();
        if (place.geometry) {
          const lat = place.geometry.location.lat();
          const lng = place.geometry.location.lng();
          isSelectingFromAutocomplete = true;
          setForm((prev) => ({
            ...prev,
            adresseClient: place.formatted_address,
            gps: `${lat}, ${lng}`,
          }));
          setTimeout(() => {
            isSelectingFromAutocomplete = false;
          }, 500);
        }
      });

      // Gestion saisie manuelle
      const input = inputRef.current;
      const manualInputHandler = () => {
        if (!isSelectingFromAutocomplete) {
          setForm((prev) => ({
            ...prev,
            adresseClient: input.value,
          }));
        }
      };
      input.addEventListener("input", manualInputHandler);

      return () => {
        input.removeEventListener("input", manualInputHandler);
      };
    };

    if (!window.google || !window.google.maps) {
      const script = document.createElement("script");
      script.src =
        "https://maps.googleapis.com/maps/api/js?key=AIzaSyCo-y50tiJe4eQoNqlXJlr3_hGeG2DB5sk&libraries=places";
      script.async = true;
      script.onload = initAutocomplete;
      document.body.appendChild(script);
    } else {
      initAutocomplete();
    }

    return () => {
      // Nettoyage optionnel
    };
  }, []);

  // Gestionnaire de changement de formulaire
  const handleChange = (e) => {
    const { name, value, type, selectedOptions } = e.target;
    if (type === "select-multiple") {
      const vals = Array.from(selectedOptions).map((o) => o.value);
      setForm((prev) => ({ ...prev, [name]: vals }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  // GARDÉ avec DEBUG: Fonction qui fonctionne pour créer ou récupérer utilisateur client
  const createOrGetClientUser = async (emailClient, nomClient, tempPassword) => {
    try {
      console.log("🔍 DEBUG: Tentative création compte pour:", emailClient);
      
      // Essayer de créer un nouveau compte (logique qui marche)
      const cred = await createUserWithEmailAndPassword(
        secondaryAuth,
        emailClient,
        tempPassword
      );
      await signOut(secondaryAuth);
      
      console.log("✅ DEBUG: Nouveau compte créé:", cred.user.uid);
      return { clientId: cred.user.uid, isNewUser: true };
      
    } catch (err) {
      console.log("❌ DEBUG: Erreur lors de la création:", err.code, "-", err.message);
      
      if (err.code === "auth/email-already-in-use") {
        console.log("🔍 DEBUG: Email déjà utilisé, recherche dans Firestore...");
        
        // Email existe déjà, récupérer l'utilisateur existant
        const q = query(
          collection(db, "users"),
          where("email", "==", emailClient)
        );
        const snap = await getDocs(q);
        
        console.log("📊 DEBUG: Résultats recherche Firestore:", snap.size, "documents trouvés");
        
        if (!snap.empty) {
          // CORRIGÉ: Gérer les doublons et s'assurer qu'on prend le bon utilisateur
          if (snap.size > 1) {
            console.log("⚠️ DEBUG: ATTENTION - Plusieurs comptes trouvés avec le même email!");
            snap.docs.forEach((doc, index) => {
              console.log(`👤 DEBUG: Compte ${index + 1}:`, {
                id: doc.id,
                email: doc.data().email,
                nom: doc.data().nom,
                role: doc.data().role,
                createdAt: doc.data().createdAt?.toDate?.()?.toLocaleDateString('fr-FR') || 'Date inconnue'
              });
            });
          }
          
          // CORRIGÉ: Utiliser le premier compte (mais maintenant on sait qu'il n'y en a qu'un après nettoyage)
          const selectedDoc = snap.docs[0];
          const userData = selectedDoc.data();
          
          console.log("✅ DEBUG: Utilisateur sélectionné:", {
            id: selectedDoc.id,
            email: userData.email,
            nom: userData.nom,
            role: userData.role
          });
          
          return { clientId: selectedDoc.id, isNewUser: false };
        } else {
          console.log("❌ DEBUG: Aucun utilisateur trouvé dans Firestore malgré l'erreur auth");
          throw new Error("Email déjà utilisé, mais utilisateur introuvable");
        }
      } else {
        console.log("❌ DEBUG: Autre erreur:", err.code);
        throw err;
      }
    }
  };

  // Soumission du formulaire
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation des champs obligatoires
    const required = ["titre", "nomClient", "emailClient", "sourceContact"];
    const missing = required.filter((f) => !form[f]?.trim());
    if (missing.length) {
      alert(`Champs requis manquants: ${missing.join(", ")}`);
      return;
    }

    let clientId;
    let tempPassword;
    let isNewUser = false;

    try {
      // GARDÉ: Créer ou récupérer utilisateur client (logique qui marche)
      tempPassword = Math.random().toString(36).slice(-8);
      const result = await createOrGetClientUser(form.emailClient, form.nomClient, tempPassword);
      clientId = result.clientId;
      isNewUser = result.isNewUser;
      
      console.log("🎯 DEBUG: clientId =", clientId, "| isNewUser =", isNewUser);

      // NOUVEAU: Si utilisateur existant, vérifier les doublons
      if (!isNewUser) {
        console.log("✅ DEBUG: Utilisateur existant trouvé, vérification des doublons...");
        
        // Récupérer tous les projets de cet utilisateur
        const existingProjectsQuery = query(
          collection(db, "dossiers"),
          where("clientId", "==", clientId)
        );
        const existingProjectsSnap = await getDocs(existingProjectsQuery);
        const existingProjects = existingProjectsSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        
        console.log("📂 DEBUG: Projets existants trouvés:", existingProjects.length);
        
        // Vérifier s'il y a un doublon exact
        const duplicateProject = checkDuplicateProject(existingProjects, form);
        
        if (duplicateProject) {
          const confirmMessage = `⚠️ ATTENTION - PROJET SIMILAIRE DÉTECTÉ ⚠️

Un projet très similaire existe déjà pour ce client :

PROJET EXISTANT :
• Titre: ${duplicateProject.title}
• Client: ${duplicateProject.clientName}
• Adresse: ${duplicateProject.clientAddress}
• Type: ${duplicateProject.typeClient}
• Créé le: ${duplicateProject.createdAt?.toDate?.()?.toLocaleDateString('fr-FR') || 'Date inconnue'}

NOUVEAU PROJET :
• Titre: ${form.titre}
• Client: ${form.nomClient}
• Adresse: ${form.adresseClient}
• Type: ${form.typeClient}

Êtes-vous sûr de vouloir créer ce projet similaire ?`;

          if (!window.confirm(confirmMessage)) {
            alert("❌ Création de projet annulée");
            return;
          }
        }
        
        console.log(`📂 DEBUG: Client existant avec ${existingProjects.length} projet(s) existant(s)`);
      }

      // Créer le dossier principal - GARDÉ
      const dossierRef = await addDoc(collection(db, "dossiers"), {
        title: form.titre,                    
        titre: form.titre,                    
        description: form.description,
        
        clientName: form.nomClient,           
        clientEmail: form.emailClient,        
        clientPhone: form.telephoneClient || "Non renseigné",    
        clientAddress: form.adresseClient,    
        
        nomClient: form.nomClient,
        emailClient: form.emailClient,
        telephoneClient: form.telephoneClient || "Non renseigné",
        adresseClient: form.adresseClient,
        
        gps: form.gps,
        typeClient: form.typeClient,
        chargeAffaires: form.chargeAffaires,
        chefsProjets: form.chefsProjets,
        superAdmins: form.superAdmins,
        sourceContact: form.sourceContact,
        raccordement: form.raccordement,
        dateLimite: form.dateLimite,
        clientId: clientId,
        createdAt: Timestamp.now(),
        updatedAt: Timestamp.now(),
        statut: "à démarrer",
        progressGlobal: 0,
        phasesChargeAffaire: [],
        phasesChefProjet: [],
        puissanceInstallation: form.puissanceInstallation || "Non définie",
        
        isMultiProject: !isNewUser
      });

      console.log("📁 DEBUG: Dossier créé avec ID:", dossierRef.id);

      // SECTION CRITIQUE AVEC DEBUG: Mettre à jour les profils clients pour multi-projets
      console.log("🔄 DEBUG: DÉBUT mise à jour des données utilisateur...");
      
      const existingUserDoc = await getDoc(doc(db, "users", clientId));
      console.log("📊 DEBUG: Document utilisateur existant trouvé:", existingUserDoc.exists());

      // CORRIGÉ: Gestion des dossierId multiples avec migration intelligente + DEBUG
      let userDossierIds = [dossierRef.id];
      
      if (existingUserDoc.exists()) {
        const userData = existingUserDoc.data();
        console.log("📊 DEBUG: Données utilisateur complètes:", userData);
        console.log("📂 DEBUG: userData.dossierIds =", userData.dossierIds);
        console.log("📂 DEBUG: userData.dossierId =", userData.dossierId);
        
        // CORRIGÉ: Logique de migration + DEBUG
        if (userData.dossierIds && Array.isArray(userData.dossierIds)) {
          // L'utilisateur a déjà le nouveau système
          userDossierIds = [...userData.dossierIds, dossierRef.id];
          console.log("✅ DEBUG: L'utilisateur a déjà le nouveau système dossierIds");
          console.log("➕ DEBUG: Ajout à dossierIds existant:", userDossierIds);
        } else if (userData.dossierId) {
          // Migration de l'ancien système vers le nouveau
          userDossierIds = [userData.dossierId, dossierRef.id];
          console.log("🔄 DEBUG: Migration de l'ancien dossierId vers dossierIds");
          console.log("📝 DEBUG: Migration ancien dossierId vers dossierIds:", userDossierIds);
        } else {
          // Aucun projet précédent (cas rare)
          console.log("🆕 DEBUG: Premier projet pour cet utilisateur existant");
        }
      } else {
        console.log("❌ DEBUG: Document utilisateur non trouvé dans Firestore");
      }

      console.log("💾 DEBUG: Mise à jour avec userDossierIds final:", userDossierIds);
      console.log("🔢 DEBUG: Nombre de projets total:", userDossierIds.length);

      const roleToSet = existingUserDoc.exists()
        ? existingUserDoc.data().role
        : "client";

      console.log("👤 DEBUG: Rôle à définir:", roleToSet);

      // MISE À JOUR clientUsers avec DEBUG
      console.log("💾 DEBUG: Mise à jour collection 'clientUsers'...");
      try {
        await setDoc(doc(db, "clientUsers", clientId), {
          email: form.emailClient,
          nom: form.nomClient,
          dossierId: dossierRef.id, // Garde pour compatibilité
          dossierIds: userDossierIds, // CORRIGÉ: Array de tous les projets
          role: roleToSet,
          createdAt: existingUserDoc.exists() ? existingUserDoc.data().createdAt : Timestamp.now(),
          updatedAt: Timestamp.now(),
          projectCount: userDossierIds.length // CORRIGÉ: Compteur de projets
        });
        console.log("✅ DEBUG: Collection 'clientUsers' mise à jour avec succès");
      } catch (clientUsersError) {
        console.log("❌ DEBUG: Erreur mise à jour 'clientUsers':", clientUsersError);
      }

      // MISE À JOUR users avec DEBUG
      console.log("💾 DEBUG: Mise à jour collection 'users'...");
      try {
        await setDoc(doc(db, "users", clientId), {
          email: form.emailClient,
          nom: form.nomClient,
          displayName: form.nomClient,
          dossierId: dossierRef.id, // Garde pour compatibilité
          dossierIds: userDossierIds, // CORRIGÉ: Array de tous les projets
          role: roleToSet,
          createdAt: existingUserDoc.exists() ? existingUserDoc.data().createdAt : Timestamp.now(),
          updatedAt: Timestamp.now(),
          projectCount: userDossierIds.length // CORRIGÉ: Compteur de projets
        });
        console.log("✅ DEBUG: Collection 'users' mise à jour avec succès");
      } catch (usersError) {
        console.log("❌ DEBUG: Erreur mise à jour 'users':", usersError);
      }

      console.log("🏁 DEBUG: FIN mise à jour des données utilisateur");
      console.log("📊 DEBUG: Résumé - dossierIds final:", userDossierIds, "| projectCount:", userDossierIds.length);

      // ✅ CORRECTION : Créer la discussion par défaut avec message de bienvenue qui compte
      const participants = [
        ...form.chargeAffaires,
        ...form.chefsProjets,
        ...form.superAdmins,
        clientId,
      ];

      const participantNames = {};
      for (const uid of [...form.chargeAffaires, ...form.chefsProjets, ...form.superAdmins]) {
        const user = users.find((u) => u.id === uid);
        if (user) participantNames[uid] = user.nom || user.displayName || user.email;
      }
      participantNames[clientId] = form.nomClient;

      const discRef = await addDoc(collection(db, "discussions"), {
        dossierId: dossierRef.id,
        dossierTitre: form.titre,
        participants,
        participantNames,
        messages: [
          {
            text: `Bienvenue dans "${form.titre}"`,
            createdAt: Timestamp.now(),
            // ✅ CORRECTION : Retirer system: true pour que le message soit compté
            createdBy: 'system',
            readBy: [], // ✅ Aucun participant ne l'a lu = comptage dans les non lus
            automatic: false, // ✅ Pas automatique pour qu'il soit visible
            userId: 'system', // ✅ Identifiant système mais pas exclu du comptage
          },
        ],
        createdAt: Timestamp.now(),
        updatedAt: Timestamp.now(),
        lastMessage: "Bienvenue dans votre espace de discussion !",
      });

      console.log("💬 DEBUG: Discussion créée avec ID:", discRef.id);

      // Créer notification principale - GARDÉ
      const creatorRole = mainAuth.currentUser
        ? (
            await getDoc(doc(db, "users", mainAuth.currentUser.uid))
          ).data()?.role || "Admin"
        : "Admin";

      const notificationData = await createNotification(
        null,
        `Nouveau dossier créé: ${form.titre}`,
        `Un nouveau dossier a été créé\nClient: ${form.nomClient}\nType: ${form.typeClient}\nSource: ${form.sourceContact}`,
        "nouveau_dossier",
        dossierRef.id,
        {
          tag: "nouveau_dossier",
          clientId,
          clientName: form.nomClient,
          clientEmail: form.emailClient,
          discussionId: discRef.id,
          participants,
          participantNames,
          createdBy: mainAuth.currentUser?.uid,
          createdByEmail: mainAuth.currentUser?.email,
          createdByRole: creatorRole,
          dossierDetails: {
            titre: form.titre,
            type: form.typeClient,
            adresse: form.adresseClient || "Non spécifiée",
            source: form.sourceContact,
            raccordement: form.raccordement,
            description: form.description || "",
            nomClient: form.nomClient,
            emailClient: form.emailClient,
            telephoneClient: form.telephoneClient || "Non renseigné",
            dateLimite: form.dateLimite,
            puissanceInstallation: form.puissanceInstallation || "Non définie",
          },
        }
      );

      // GARDÉ: Envoyer e-mail client seulement si nouvel utilisateur
      let emailSent = false;
      if (isNewUser && tempPassword) {
        console.log("📧 DEBUG: Envoi d'email de bienvenue (nouvel utilisateur)");
        for (let attempt = 1; attempt <= 3; attempt++) {
          try {
            const emailResult = await sendWelcomeEmail({
              email: form.emailClient,
              nom: form.nomClient,
              password: tempPassword,
              dossierId: dossierRef.id,
            });
            if (emailResult.success) {
              emailSent = true;
              console.log("✅ DEBUG: Email envoyé avec succès");
              break;
            }
          } catch (attemptError) {
            console.error(
              `❌ DEBUG: Échec tentative ${attempt}:`,
              attemptError.message
            );
            if (attempt < 3)
              await new Promise((resolve) => setTimeout(resolve, 1000));
          }
        }
      } else {
        console.log("📧 DEBUG: Pas d'email envoyé (utilisateur existant)");
        emailSent = "Utilisateur existant - Pas d'email envoyé";
      }

      // GARDÉ: Message de confirmation
      const infoMessage = `
✅ Dossier créé avec succès !
ID du dossier: ${dossierRef.id}
URL: ${window.location.origin}/client/${dossierRef.id}
Email client: ${form.emailClient}
${isNewUser ? `Mot de passe temporaire: ${tempPassword}` : 'Utilisateur existant - Utilise son mot de passe actuel'}
Puissance: ${form.puissanceInstallation || "Non définie"}
Source: ${form.sourceContact}
👤 ${isNewUser ? 'Nouvel utilisateur créé' : `Utilisateur existant - Total projets: ${userDossierIds.length}`}
${typeof emailSent === 'string' ? emailSent : (emailSent ? "✔️ Email envoyé au client" : "⚠️ Email non envoyé")}
`;
      alert(infoMessage);
      navigate("/admin/dossiers");
    } catch (error) {
      console.error("❌ DEBUG: Erreur lors de la création du dossier:", error);
      alert(`Erreur lors de la création: ${error.message}`);
    }
  };

  const renderOptions = (role) =>
    users
      .filter((u) => u.role === role)
      .map((u) => (
        <option key={u.id} value={u.id}>
          {u.nom || u.displayName || u.email}
        </option>
      ));

  return (
    <div className="max-w-5xl mx-auto p-8 bg-white shadow-xl rounded-xl">
      <h2 className="text-2xl font-semibold mb-6 text-center">
        Créer un nouveau dossier
      </h2>
      <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Champs principaux */}
        <input
          name="titre"
          placeholder="Titre *"
          value={form.titre}
          onChange={handleChange}
          className="border p-3 rounded-lg"
        />
        <input
          name="nomClient"
          placeholder="Nom du client *"
          value={form.nomClient}
          onChange={handleChange}
          className="border p-3 rounded-lg"
        />
        <input
          name="emailClient"
          type="email"
          placeholder="Email du client *"
          value={form.emailClient}
          onChange={handleChange}
          className="border p-3 rounded-lg"
        />
        <input
          name="telephoneClient"
          placeholder="Téléphone"
          value={form.telephoneClient}
          onChange={handleChange}
          className="border p-3 rounded-lg"
        />

        {/* Adresse avec Google Maps */}
        <input
          name="adresseClient"
          ref={inputRef}
          placeholder="Adresse"
          value={form.adresseClient}
          onChange={handleChange}
          className="border p-3 rounded-lg"
        />
        <input
          name="gps"
          placeholder="Coordonnées GPS"
          readOnly
          value={form.gps}
          className="border p-3 rounded-lg bg-gray-100"
        />
        <textarea
          name="description"
          placeholder="Description du projet"
          rows={3}
          value={form.description}
          onChange={handleChange}
          className="col-span-2 border p-3 rounded-lg"
        />

        {/* Sélection des responsables */}
        <div>
          <label>Chargés d'affaires</label>
          <select
            name="chargeAffaires"
            multiple
            onChange={handleChange}
            className="w-full border p-2 rounded-lg"
          >
            {renderOptions("charge-affaire")}
          </select>
        </div>
        <div>
          <label>Chefs de projet</label>
          <select
            name="chefsProjets"
            multiple
            onChange={handleChange}
            className="w-full border p-2 rounded-lg"
          >
            {renderOptions("projectmanager")}
          </select>
        </div>
        <div>
          <label>Super Admins</label>
          <select
            name="superAdmins"
            multiple
            onChange={handleChange}
            className="w-full border p-2 rounded-lg"
          >
            {renderOptions("superadmin")}
          </select>
        </div>

        {/* Champs additionnels */}
        <select
          name="typeClient"
          value={form.typeClient}
          onChange={handleChange}
          className="border p-3 rounded-lg"
        >
          <option value="professionnel">Professionnel</option>
          <option value="particulier">Particulier</option>
          <option value="collectivite">Collectivité</option>
        </select>

        <select
          name="sourceContact"
          value={form.sourceContact}
          onChange={handleChange}
          className="border p-3 rounded-lg"
          required
        >
          <option value="">-- Source de contact --</option>
          <option value="site web">Site web</option>
          <option value="réseaux sociaux">Réseaux sociaux</option>
          <option value="salon/événement">Salon / Événement</option>
          <option value="publicité">Publicité</option>
          <option value="partenariat">Partenariat</option>
          <option value="prospection">Prospection directe</option>
          <option value="autre">Autre</option>
        </select>

        <select
          name="raccordement"
          value={form.raccordement}
          onChange={handleChange}
          className="border p-3 rounded-lg"
        >
          <option value="autoconsommation">Autoconsommation</option>
          <option value="revente totale">Revente totale</option>
          <option value="revente surplus">Revente de surplus</option>
        </select>

        <input
          name="dateLimite"
          type="date"
          value={form.dateLimite.split("T")[0]}
          onChange={handleChange}
          className="border p-3 rounded-lg w-full"
        />

        {/* Champ ajouté : Puissance installation */}
        <input
          name="puissanceInstallation"
          placeholder="Puissance (kWc)"
          value={form.puissanceInstallation}
          onChange={handleChange}
          className="border p-3 rounded-lg"
        />

        <button
          type="submit"
          className="col-span-2 mt-4 bg-green-500 text-white px-6 py-3 rounded-lg hover:bg-green-600"
        >
          🚀 Créer le dossier
        </button>
      </form>
    </div>
  );
}

// Fonction d'envoi d'email
const sendWelcomeEmail = async (userData) => {
  const { email, nom, password, dossierId } = userData;

  const templateParams = {
    to_email: email, // ✅ Doit être l'e-mail du client
    to_name: nom,
    password,
    dashboard_url: `${window.location.origin}/client/${dossierId}`,
  };

  try {
    console.log("📧 Tentative d'envoi d'email via EmailJS...");
    const emailjsResult = await emailjs.send(
      EMAIL_SERVICE_ID,
      EMAIL_TEMPLATE_ID,
      templateParams
    );
    console.log("✅ Email envoyé avec succès via EmailJS:", emailjsResult);
    return { success: true };
  } catch (error) {
    console.error("❌ Échec envoi email:", error.message);
    return { success: false, error: error.message };
  }
};